import React from 'react'
import Icon from '../../icon'
import Submenu from '../sub-menu'
import * as Styles from './styles'

type Props = {
  active?: boolean
  icon?: string
  img?: string | JSX.Element
  isOpen?: boolean
  disabled?: boolean
  notification?: boolean
  text: string
  visible?: boolean
  handleEvent: () => void
  submenu?: ISubitem[]
  submenuTitle?: ISubitemTitle[]
}

interface ISubitem {
  text: string
  handleEvent: Function
}

interface ISubitemTitle {
  title: string
  subitem: ISubitem[]
  handleEvent: Function
}

const renderImg = (img) => {
  if (typeof img === 'string') {
    return (
      <Styles.Img>
        <img src={img} alt="img" />
      </Styles.Img>
    )
  } else if (React.isValidElement(img)) {
    return <Styles.Img>{img}</Styles.Img>
  }
  return null
}

const Item: React.FC<Props> = (props: Props) => {
  const disabledTheme = `${props.disabled ? 'is-disabled' : ''}`
  const [isOpen, setOpen] = React.useState(
    Boolean(props.submenu) && props.isOpen,
  )

  const [isOpenSubmenuTitle, setOpenSubmenuTitle] = React.useState(
    Boolean(props.submenuTitle) && props.isOpen,
  )

  const handleClick = (): void => {
    if (props.submenu) {
      return setOpen(!isOpen)
    }
    if (props.submenuTitle) {
      return setOpenSubmenuTitle(!isOpenSubmenuTitle)
    }
    return props.handleEvent()
  }

  const renderSubmenuArrow = (): React.ReactNode => (
    <Styles.SubmenuArrow>
      <Styles.Icon>
        <Icon name={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
      </Styles.Icon>
    </Styles.SubmenuArrow>
  )

  return (
    <Styles.Item active={props.active} notification={props.notification}>
      <Styles.Button
        onClick={() => !props.disabled && handleClick()}
        className={isOpen && 'is-open'}
        disabled={props.disabled}
      >
        {props.notification && !props.active && (
          <Styles.WrapperNotification notification={props.notification} />
        )}
        <Styles.Icon className={disabledTheme}>
          {props.icon && <Icon name={props.icon} />}
          {props.img && !props.icon && renderImg(props.img)}
        </Styles.Icon>

        <Styles.SubmenuContainer>
          <Styles.Text className={disabledTheme}>{props.text}</Styles.Text>
          {Boolean(props.submenu) && renderSubmenuArrow()}
          {Boolean(props.submenuTitle) && renderSubmenuArrow()}
        </Styles.SubmenuContainer>
      </Styles.Button>
      {Boolean(props.submenu) && (
        <Submenu
          isOpen={isOpen}
          submenu={props.submenu}
          notification={props.notification}
        />
      )}
      {Boolean(props.submenuTitle) && (
        <Submenu
          isOpen={isOpenSubmenuTitle}
          submenuTitle={props.submenuTitle}
        />
      )}
    </Styles.Item>
  )
}

Item.defaultProps = {
  active: false,
  notification: false,
  isOpen: false,
  disabled: false,
}

export default Item
